const ONE_MINUTE = 60 * 1000;
const ONE_DAY = ONE_MINUTE * 60 * 24;

export { ONE_DAY, ONE_MINUTE };
